import { Box } from '@mui/material';
import { FC } from 'react';
import { env } from '../../../config/env';
import OtherCountryIcon from './OtherCountryIcon';

interface CountryFlagIconProps {
  size?: number;
  countryName?: string;
  flagImageName?: string;
}

const CountryFlagIcon: FC<CountryFlagIconProps> = ({ size = 24, countryName, flagImageName }) => {
  if (!flagImageName) {
    return <OtherCountryIcon countryName={countryName || ''} size={size} />
  }

  return (
    <Box
      component="img"
      alt={countryName}
      src={`${env.imageBaseUrl}/CountryFlags/${flagImageName}`}
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        objectFit: 'cover'
      }}
    />
  );
}

export default CountryFlagIcon; 